module.exports = __webpack_public_path__ + "img/Nevrome_de_Morton_pied.2d2b1dcf.jpg";